<style lang="scss" scoped>
  @import '../../../sass/_variables';

  .table {
    tr:first-child {
      td {
        border: 0;
      }
    }

    .empty {
      background: $white;

      td {
        color: $gray-light;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: -0.17px;
        padding: 2px 0 1px;

        .small-text {
          font-size: 0.6875rem;
        }
      }
    }
  }
</style>

<template>
  <div class="integration-imap">
    <div class="form-group">
      <label class="d-flex align-items-center">Integração IMAP
        <div class="mt-n4 ml-auto">
          <button
            class="btn btn-primary"
            type="button"
            @click="open()"
          >
            <IconPlus />
          </button>
        </div>
      </label>
      <table class="table mt-10px">
        <tbody v-if="loading">
          <tr class="empty">
            <td class="pt-10px">
              <i class="fa fa-circle-o-notch fa-spin" /><span class="ml-2">{{ __('Carregando...') }}</span>
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="tokens.length">
          <tr
            :key="token.id"
            v-for="(token, index) in tokens"
          >
            <td>
              <div class="row">
                <div class="col-xl-6">
                  {{ token.host }}:{{ token.port }}
                </div>
                <div class="col-xl-6">
                  {{ token.username }}
                </div>
              </div>
            </td>
            <td class="d-flex align-items-center">
              <a
                class="ml-auto"
                href="#"
                @click.prevent="open(token)"
                v-b-tooltip.bottomleft="'Editar acesso'"
              >
                <IconPencilFilled :size="18" /></a><a
                class="ml-3"
                href="#"
                @click.prevent="destroy(token, index)"
                v-b-tooltip.bottomleft="'Remover acesso'"
              >
                <IconTrash :size="18" /></a>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr class="empty">
            <td><span class="none">{{ __('Nenhum e-mail cadastrado') }}</span><br><small class="small-text">{{ __('Clique em "+" para autorizar o Salesflow') }}.</small></td>
          </tr>
        </tbody>
      </table>
    </div>
    <BModal
      id="modal-imap-integration"
      modal-class="modal-no-header-no-footer"
      ref="modal-imap-integration"
      size="lg"
      hide-header="hide-header"
      hide-footer="hide-footer"
    >
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="close()"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title align-items-center text-center">
        {{ __('Integração IMAP') }}
      </h4>
      <div class="form-group">
        <p class="form-text">
          {{ __('Para configurar a integração IMAP adicione servidor, porta, usuário e senha e clique em salvar') }}.
        </p>
        <form @submit.prevent="save()">
          <div class="row">
            <div class="col-9">
              <label class="lg">{{ __('Servidor IMAP') }}</label>
              <p>
                <input
                  class="form-control"
                  type="text"
                  v-model="token.host"
                  required="required"
                >
              </p>
            </div>
            <div class="col-3">
              <label class="lg">Porta IMAP</label>
              <p>
                <input
                  class="form-control"
                  type="text"
                  v-model="token.port"
                  required="required"
                >
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label class="lg">{{ __('Usuário') }}</label>
              <p>
                <input
                  class="form-control"
                  type="text"
                  v-model="token.username"
                  required="required"
                >
              </p>
            </div>
            <div class="col-6">
              <label class="lg">{{ __('Senha') }}</label>
              <p>
                <input
                  class="form-control"
                  type="password"
                  v-model="token.password"
                  :required="! token.id"
                  :placeholder="placeholder"
                >
              </p>
            </div>
          </div>
          <div class="form-group mt-5">
            <hr>
          </div>
          <div class="modal-footer default-modal-footer">
              <button
                class="salesflow-btn salesflow-btn-secondary f-w-500"
                type="submit"
                :disabled="saving"
              >
                <span v-if="saving">{{ __('Salvando') }}<i class="fa fa-circle-o-notch fa-spin ml-1" /></span><span v-else>{{ __('Salvar') }}</span>
              </button>
          </div>
        </form>
      </div>
    </BModal>
  </div>
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    root: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    token: {},
    tokens: [],
    loading: true,
    saving: false,
  }),

  created () {
    this.fetch();
  },

  computed: {
    placeholder () {
      if (this.token.id) {
        return 'Deixe em branco para não alterar';
      }
    },
  },

  methods: {
    open (token = {}) {
      this.token = { ...token };
      this.editingToken = token;

      this.$refs['modal-imap-integration'].show();
    },

    close () {
      this.$refs['modal-imap-integration'].hide();
    },

    mapping (token = {}) {
      token.host = token.metadata.host;
      token.port = token.metadata.port;
      token.username = token.provider_id;

      delete token.provider_id;
      delete token.metadata;

      return token;
    },

    fetch () {
      this.loading = true;

      this.$http.get('/user/imap')
        .then(({ data }) => {
          this.tokens = data.map((token) => this.mapping(token));
        })
        .finally(() => this.loading = false);
    },

    save () {
      this.saving = true;

      if (this.token.id) {
        return this.update();
      }

      this.create();
    },

    create () {
      this.$http.post('/user/imap', this.token)
        .then(({ data }) => {
          this.tokens.push(this.mapping(data));

          this.close();
        })
        .catch(({ status, body = {} }) => {
          if (status === 422) {
            return Alert.error(body.error || 'Não permitido. Configuração já existe!');
          }

          Alert.error(this.__('Erro ao salvar configuração.'));
        })
        .finally(() => this.saving = false);
    },

    update () {
      const index = this.tokens.indexOf(this.editingToken);

      this.$http.put(`/user/imap/${this.token.id}`, this.token)
        .then(({ data }) => {
          this.tokens.splice(index, 1, this.mapping(data));

          this.close();
        })
        .catch(({ status, body = {} }) => {
          if (status === 422) {
            return Alert.error(body.error || 'Não permitido. Configuração já existe!');
          }

          Alert.error(this.__('Erro ao salvar configuração.'));
        })
        .finally(() => this.saving = false);
    },

    async destroy (token, index) {
      const title = this.__('Deseja mesmo excluir?');
      const text = this.__('Esta ação não poderá ser desfeita!');

      if (! await Confirm(title, text)) {
        return;
      }

      this.$http.delete(`/user/token/${token.id}`)
        .then(({ data }) => this.tokens.splice(index, 1));
    },
  },
};
</script>
